import React from 'react';

import './HomeLoader.css';

const HomeLoader = () => {
    return (
        <div>
            <div className="loading__backdrop"></div>
        </div>
    );
};

export default HomeLoader;
